<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="11">
        <v-row align="baseline">
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.street"
              :label="$t('PROFILE.STREET')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.zip"
              :label="$t('PROFILE.ZIP')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="currFilters.city"
              :label="$t('PROFILE.CITY')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <building-complexes-filter
              v-model="currFilters.building_complex"
              item-text="name"
              item-value="id"
              :label="$t('BUILDING_COMPLEXES.ITEMS')"
              multiple
              chips
              small-chips
              deletable-chips
            />
          </v-col>
        </v-row>
        <v-row class="mt-0" align="baseline">
          <v-col cols="6" md="3">
            <business-customers-filter
              v-model="currFilters.business_customer"
              item-text="name"
              item-value="name"
              :label="$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <concierges-filter
              v-model="currFilters.concierge"
              item-text="full_name"
              item-value="full_name"
              :label="$t('BUILDING_COMPLEXES.CONCIERGE')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <management-companies-filter
              v-model="currFilters.management_company"
              item-text="name"
              item-value="name"
              :label="$t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY')"
            />
          </v-col>
          <v-col cols="6" md="3">
            <statuses-filter
              v-model="currFilters.status"
              item-value="id"
              item-text="name"
              :label="$t('ITEM.STATUS')"
              chips
              multiple
              clearable
              small-chips
              deletable-chips
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="1"
        align-self="center"
        class="d-flex flex-wrap justify-md-space-between"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mb-1 mr-1"
              color="grey"
              depressed
              outlined
              @click="reset"
              v-on="on"
            >
              <v-icon>mdi-filter-remove</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
        </v-tooltip>
        <v-btn
          class="mb-1"
          type="submit"
          color="primary"
          depressed
          @click.prevent="setFilters"
        >
          {{ $t('BUTTON.FIND') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import ConciergesFilter from '@/modules/building_complexes/components/filters/ConciergesFilter.vue';
import BusinessCustomersFilter from '@/modules/_global/_components/list_filters/BusinessCustomer/BusinessCustomersSelectFilter.vue';
import ManagementCompaniesFilter from '@/modules/_global/_components/list_filters/ManagementCompany/ManagementCompaniesSelectFilter.vue';
import StatusesFilter from './filters/StatusesFilter.vue';
import BuildingComplexesFilter from '@/modules/_global/_components/list_filters/BuildingComplex/BuildingComplexesFilter.vue';
import listFilters from '@/modules/_global/mixins/list-filters';
import { mapState } from 'vuex';

export default {
  name: 'BuildingsListFilters',

  components: {
    StatusesFilter,
    ConciergesFilter,
    BusinessCustomersFilter,
    BuildingComplexesFilter,
    ManagementCompaniesFilter
  },

  mixins: [listFilters],

  computed: {
    ...mapState('building', ['filters'])
  },

  methods: {
    reset() {
      this.$refs.form.reset();
      this.currFilters = {};
      this.setFilters();
    }
  }
};
</script>
